import { Button } from 'flowbite-react'
import type { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message) {
    return error.message
  }

  return fallback
}

export default function GlobalFallback({ error, resetErrorBoundary }: FallbackProps) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen items-center justify-center error-page-bg px-4 py-8">
      <div className="error-card-surface w-full max-w-xl rounded-xl p-6 shadow-sm">
        <p className="text-sm font-semibold uppercase tracking-wide text-red-700 dark:text-red-300">{t('errors.global.tag')}</p>
        <h1 className="mt-2 text-xl font-semibold">{t('errors.global.title')}</h1>
        <p className="mt-2 text-sm opacity-90">{t('errors.global.description')}</p>
        <p className="error-detail-box mt-4 rounded-md p-3 text-sm">
          {getErrorMessage(error, t('errors.global.unexpectedError'))}
        </p>
        <div className="mt-4">
          <Button color="failure" onClick={resetErrorBoundary}>{t('errors.actions.retry')}</Button>
        </div>
      </div>
    </div>
  )
}
